<template>
  <div id="app">
  <ui></ui>
  </div>
</template>

<script>
    import ui from "./components/ui.vue";

    export default {
        name: "app",
        components: {
            "ui": ui
        }
    };

</script>

<style lang="scss">
    $max-container-width: 1240px;
    $min-container-width: 320px;
    body{
        margin: 0 auto;
        background: rgba(0,0,0,0.9);
        width: 100vw;
        height: 100vh;
    }
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin: 0 auto;
        max-width: $max-container-width;
        min-width: $min-container-width;
        width: 100%;
        height: 100%;
        background: white;
        overflow-x: hidden;
    }

</style>
